import PublicRouter from "router/PublicRouter"
import { PublicProvider } from "store/context/PublicContext"
import AppProvider from "store/providers/AppProvider"
import { Flowbite } from "flowbite-react"
import get_flowbite_theme from "utils/get_flowbite_theme/base"
import { Auth0Provider } from "@auth0/auth0-react"
import useAuth0Credentials from "hooks/useAuth0Credentials"
import { Toaster as HotToaster } from "react-hot-toast"
import "assets/css/global.css"
import "webcomponent/JsonViewer/index"
import LocationsProvider from "store/providers/LocationsProvider"
import { BrowserRouter } from "react-router-dom"

const AppContainer = () => {
  const { clientId, domain, audience } = useAuth0Credentials()

  return (
    <Flowbite theme={{ theme: get_flowbite_theme }}>
      <BrowserRouter>

        <HotToaster position="bottom-right" reverseOrder={false} />
        <Auth0Provider
          key={clientId}
          clientId={clientId}
          domain={domain}
          authorizationParams={{
            redirect_uri: `${window.location.origin}/callback`,
            audience: audience,
          }}
          cacheLocation="localstorage"
          useRefreshTokens={true}
        >
          <PublicProvider>
            <LocationsProvider>
              <AppProvider>
                <PublicRouter />
              </AppProvider>
            </LocationsProvider>
          </PublicProvider>
        </Auth0Provider>
      </BrowserRouter>
    </Flowbite>
  )
}

export default AppContainer
